import React from 'react'

import { useGetTypeOfBottleFromUrl } from 'src/hooks'

import styles from './InputInfoForCreateBottle.module.scss'
import { Charitable, Lottery } from './components'

const InputInfoForCreateBottle = () => {
  const typeOfBottle = useGetTypeOfBottleFromUrl()

  return (
    <div className={styles.wrapper}>
      {typeOfBottle === 'charitable' && <Charitable />}
      {typeOfBottle === 'lottery' && <Lottery styles={styles} />}
    </div>
  )
}

export default InputInfoForCreateBottle
